<script>
  import { currentScreen } from '../store.js';
  import { availableTeams } from '../store.js';
  import { appSettings } from '../../store.js';
  import { toast } from '../../ui/dialogs.js';
  import { FFPL_PLAYER_POOL } from '../../teams-data.js';

  let teamA = "";
  let teamB = "";
  let overs = 10;
  let scheduledDate = "";
  let scheduledTime = "";
  let venue = appSettings.venue || "Rohini Sec 28";

  // Player arrays — initialized when a team is selected
  let playersA = new Array(8).fill("");
  let playersB = new Array(8).fill("");

  // Auto-fill captain as first player when team is selected
  $: {
    if (teamA) {
      const t = $availableTeams.find(t => t.name === teamA);
      if (t && t.captain && !playersA[0]) playersA[0] = t.captain;
    }
  }
  $: {
    if (teamB) {
      const t = $availableTeams.find(t => t.name === teamB);
      if (t && t.captain && !playersB[0]) playersB[0] = t.captain;
    }
  }

  function goBack() {
    currentScreen.set('home');
  }

  function addPlayer(teamSlot) {
    if (teamSlot === 'A') playersA = [...playersA, ""];
    if (teamSlot === 'B') playersB = [...playersB, ""];
  }

  function removePlayer(teamSlot) {
    if (teamSlot === 'A' && playersA.length > 2) playersA = playersA.slice(0, -1);
    if (teamSlot === 'B' && playersB.length > 2) playersB = playersB.slice(0, -1);
  }

  function scheduleMatch() {
    if (!teamA || !teamB) {
      toast("Please select both teams.", "error");
      return;
    }
    if (teamA === teamB) {
      toast("Teams must be different.", "error");
      return;
    }
    if (!scheduledDate || !scheduledTime) {
      toast("Please select a date and time.", "error");
      return;
    }

    const scheduledMatches = JSON.parse(localStorage.getItem('cs_scheduled_v1') || "[]");
    
    // Grab full team objects
    const tA = $availableTeams.find(t => t.name === teamA);
    const tB = $availableTeams.find(t => t.name === teamB);

    // Filter out empty player names
    const filteredA = playersA.filter(p => p.trim());
    const filteredB = playersB.filter(p => p.trim());

    scheduledMatches.push({
      id: "sch_" + Date.now(),
      teamA: tA,
      teamB: tB,
      overs,
      venue,
      date: scheduledDate,
      time: scheduledTime,
      playersA: filteredA.length > 0 ? filteredA : null,
      playersB: filteredB.length > 0 ? filteredB : null,
      createdAt: Date.now()
    });

    localStorage.setItem('cs_scheduled_v1', JSON.stringify(scheduledMatches));
    toast("📅 Match scheduled successfully!", "success");
    currentScreen.set('home');
  }
</script>

<datalist id="schedule-player-pool">
  {#each FFPL_PLAYER_POOL as p, i_each (p.id || p.name || i_each)}
    <option value={p}></option>
  {/each}
</datalist>

<div class="screen" style="overflow-y:auto; padding-bottom:60px;">
  <button class="btn btn-ghost" on:click={goBack}>← Back</button>
  <h1 style="margin-top:10px">Schedule Match</h1>

  <div class="card">
    <div class="field">
      <label for="schedule-team-a">Team A</label>
      <select id="schedule-team-a" bind:value={teamA} on:change={() => { playersA = new Array(8).fill(""); if (teamA) { const t = $availableTeams.find(x => x.name === teamA); if (t?.captain) playersA[0] = t.captain; playersA = playersA; } }}>
        <option value="">Select Team</option>
        {#each $availableTeams as t, i_each (t.id || t.name || i_each)}
          <option value={t.name} disabled={t.name === teamB}>{t.name}</option>
        {/each}
      </select>
    </div>

    <div class="field">
      <label for="schedule-team-b">Team B</label>
      <select id="schedule-team-b" bind:value={teamB} on:change={() => { playersB = new Array(8).fill(""); if (teamB) { const t = $availableTeams.find(x => x.name === teamB); if (t?.captain) playersB[0] = t.captain; playersB = playersB; } }}>
        <option value="">Select Team</option>
        {#each $availableTeams as t, i_each (t.id || t.name || i_each)}
          <option value={t.name} disabled={t.name === teamA}>{t.name}</option>
        {/each}
      </select>
    </div>

    <div class="field">
      <label for="schedule-overs">Overs</label>
      <select id="schedule-overs" bind:value={overs}>
        {#each [2, 5, 8, 10, 12, 15, 20] as o, i_each (o.id || o.name || i_each)}
          <option value={o}>{o} Overs</option>
        {/each}
      </select>
    </div>

    <div class="field">
      <label for="schedule-date">Date</label>
      <input id="schedule-date" type="date" bind:value={scheduledDate} style="width:100%; padding:8px; border-radius:4px; border:1px solid #333; background:#222; color:white;" />
    </div>

    <div class="field">
      <label for="schedule-time">Time</label>
      <input id="schedule-time" type="time" bind:value={scheduledTime} style="width:100%; padding:8px; border-radius:4px; border:1px solid #333; background:#222; color:white;" />
    </div>

    <div class="field">
      <label for="schedule-venue">Venue</label>
      <input id="schedule-venue" type="text" bind:value={venue} style="width:100%; padding:8px; border-radius:4px; border:1px solid #333; background:#222; color:white;" />
    </div>
  </div>

  <!-- TEAM A PLAYERS -->
  {#if teamA}
    <div class="card" style="margin-top:12px;">
      <div style="font-weight:800; margin-bottom:8px; color:#fbbf24; letter-spacing:0.5px; font-size:13px;">
        {teamA} — PLAYERS
      </div>
      <div class="muted" style="font-size:10px; margin-bottom:8px;">Pre-fill players now or enter them at match time.</div>
      {#each playersA as p, i (i)}
        <div style="display:flex; align-items:center; gap:6px; margin-bottom:4px;">
          <div style="width:24px; text-align:center; font-size:12px; color:#9ca3af;">{i === 0 ? "👑" : String(i + 1)}</div>
          <input type="text" list="schedule-player-pool" bind:value={playersA[i]} placeholder={i === 0 ? "Captain" : "Player " + (i + 1)} style="flex:1; padding:6px 8px; border-radius:4px; border:1px solid #333; background:#1a1a2e; color:white; font-size:13px;" />
        </div>
      {/each}
      <div style="display:flex; gap:8px; margin-top:8px;">
        <button class="btn btn-ghost" style="font-size:11px; padding:4px 10px;" on:click={() => addPlayer('A')}>+ Add Player</button>
        <button class="btn btn-ghost" style="font-size:11px; padding:4px 10px;" disabled={playersA.length <= 2} on:click={() => removePlayer('A')}>- Remove</button>
      </div>
    </div>
  {/if}

  <!-- TEAM B PLAYERS -->
  {#if teamB}
    <div class="card" style="margin-top:12px;">
      <div style="font-weight:800; margin-bottom:8px; color:#fbbf24; letter-spacing:0.5px; font-size:13px;">
        {teamB} — PLAYERS
      </div>
      <div class="muted" style="font-size:10px; margin-bottom:8px;">Pre-fill players now or enter them at match time.</div>
      {#each playersB as p, i (i)}
        <div style="display:flex; align-items:center; gap:6px; margin-bottom:4px;">
          <div style="width:24px; text-align:center; font-size:12px; color:#9ca3af;">{i === 0 ? "👑" : String(i + 1)}</div>
          <input type="text" list="schedule-player-pool" bind:value={playersB[i]} placeholder={i === 0 ? "Captain" : "Player " + (i + 1)} style="flex:1; padding:6px 8px; border-radius:4px; border:1px solid #333; background:#1a1a2e; color:white; font-size:13px;" />
        </div>
      {/each}
      <div style="display:flex; gap:8px; margin-top:8px;">
        <button class="btn btn-ghost" style="font-size:11px; padding:4px 10px;" on:click={() => addPlayer('B')}>+ Add Player</button>
        <button class="btn btn-ghost" style="font-size:11px; padding:4px 10px;" disabled={playersB.length <= 2} on:click={() => removePlayer('B')}>- Remove</button>
      </div>
    </div>
  {/if}

  <button class="btn btn-primary btn-block" style="margin-top:20px;" on:click={scheduleMatch}>
    Save Scheduled Match
  </button>
</div>
